import React from 'react';
import {
  FOOTER_PARAGRAPH_1, FOOTER_PRE_POLICY, FOOTER_POST_POLICY,
} from './consts';

function Footer() {
  return (
    <footer>
      <p>{FOOTER_PARAGRAPH_1}</p>
      <p>
        <strong>Personal Information Collection Statement</strong>
        <br />
        {FOOTER_PRE_POLICY}
        <a href="/company/privacy" target="_new">privacy policy</a>
        {FOOTER_POST_POLICY}
      </p>
    </footer>
  );
}

export default React.memo(Footer);
